import { createContext } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { apiURL } from '../../store/actions/authActions'
import { useState, useEffect } from 'react'
import { prsCodes } from '../utils/api'
import { MutateLogin, MutateSSOLogin, MutateUserPersona } from '../hooks/mutations'
import { getItem, saveItem } from '../utils/localForage'
import { useSelector } from 'react-redux'
import localforage from 'localforage'
import LogRocket from 'logrocket'
import { useMutation } from '@tanstack/react-query'
import { agentVerify } from '../hooks/apis'

export const AuthContext = createContext()

export const AuthProvider = ({ children }) => {
  const { search } = useLocation()
  const query = new URLSearchParams(search)
  const location = useLocation()
  const userSourceCode = query.get('userSourceCode') || ''
  const [productId, setProductId] = useState(query.get('productId') || location.state?.productId || '')
  const [affiliateCode, setAffiliateCode] = useState(query.get('affiliateCode') || location.state?.affiliateCode || '')
  const [company, setCompany] = useState(
    productId === '4127' || window.location.href.includes('lwp')
      ? 'foresters'
      : productId === '81403' || window.location.href.includes('assure')
      ? 'assure'
      : productId === '511801' || window.location.href.includes('newbridgefx')
      ? 'avant'
      : productId === '81401' || window.location.href.includes('qlt')
      ? 'sbli'
      : ''
  )
  const [orgObject, setOrgObject] = useState({
    orgName: '',
    companyLogo: null,
  })
  const [agentObject, setAgentObject] = useState({
    firstName: '',
    lastName: '',
    photo: null,
  })
  const [invalidUrl, setInvalidUrl] = useState(false)
  const [urlErrorMessage, setUrlErrorMessage] = useState('')
  const [alerts, setAlerts] = useState([])
  const [authObj, setAuthObj] = useState({
    isAuthenticated: false,
    otpFlag: false,
    user: null,
    relationalType: null,
    userSourceCode: null,
  })
  const [isAgentVerifyError, setIsAgentVerifyError] = useState(false)
  const [agentVerifyError, setAgentVerifyError] = useState({
    msgTitle: 'Could not validate agent',
    msgText: 'There was a problem while validating the agent.',
  })
  const [loginPassword, setLoginPassword] = useState('')

  const loggedIn = useSelector((state) => state.auth.isAuthenticated)
  const aState = useSelector((state) => state.auth)
  const affCodeFromRedux = useSelector((state) => state.auth.affiliateCode)
  const affiliateCodeFromRedux = useSelector((state) => state.auth.affiliateCode)
  const productIdExist = productId
  const affiliateCodeExist = affiliateCode || affiliateCodeFromRedux
  const prodMap = {
    lwp: '4127',
    qlt: '81401',
    assure: '81403',
    newbridgefx: '511801',
  }
  const isInvalidUrl = () => {
    console.log('saurabh: ', productIdExist)
    if (loggedIn || authObj.isAuthenticated) return false

    if (!productIdExist) {
      return true
    } else {
      switch (productIdExist) {
        case '4127':
          return false

        case '81401':
          if (!affiliateCodeExist) {
            return true
          } else {
            return false
          }
        default:
          break
      }
    }
    return false
  }

  const {
    data: loginData,
    mutate: login,
    isPending: loggingIn,
    error: loginError,
    isError: isLoginError,
  } = MutateLogin()
  const { data: personaData, mutate: getUserPersona, isPending: gettingPersona } = MutateUserPersona()
  const { data: ssoData, mutate: ssoLogin, isPending: ssoLoggingIn } = MutateSSOLogin()
  const { mutate: mutateAgentVerify, isPending: verifyingAgent } = useMutation({
    mutationKey: 'agentVerify',
    mutationFn: agentVerify,
    onSuccess: (data, variables) => {
      saveItem('authObj', JSON.stringify(authObj))
      saveItem('affiliateCode', affiliateCode)
      console.log('calling getUserPersona')
      getUserPersona(variables.agentEmail)
    },
    onError: (error) => {
      setAuthObj({
        isAuthenticated: false,
        otpFlag: false,
        user: null,
        relationalType: null,
        userSourceCode: null,
      })
      setIsAgentVerifyError(true)
      setAgentVerifyError({
        msgTitle: error.msgTitle,
        msgText: error.msgText,
      })
      console.log('Error', error)
    },
  })

  const navigate = useNavigate()

  const verifyAuthentication = async () => {
    const storedState = await getItem('authObj')
    const storedAgentState = await getItem('agentObject')
    const storedAffiliateCode = await getItem('affiliateCode')
    // console.log({ storedAffiliateCode })
    if (storedState) setAuthObj(JSON.parse(storedState))
    if (storedAgentState) setAgentObject(JSON.parse(storedAgentState))
    if (storedAffiliateCode) setAffiliateCode(storedAffiliateCode)
  }

  const storeProductId = async (newProdId) => {
    const storedProdId = await getItem('productId')
    console.log({ storedProdId })
    if ((!storedProdId || storedProdId !== newProdId) && newProdId !== undefined) {
      console.log({ newProdId })

      saveItem('productId', newProdId)
      setProductId(newProdId)
    } else if (storedProdId) {
      console.log('setting')
      setProductId(storedProdId)
    }
  }

  useEffect(() => {
    if (productId === '4127') {
      setCompany('foresters')
    }
  }, [productId])

  useEffect(() => {
    if (!loggedIn || productId === '4127' || location.pathname !== '/login') return
    console.log('logging in')
    // navigate(`/home`)
    navigate(`/application-management?affiliateCode=${affCodeFromRedux || affiliateCode}`)
  }, [loggedIn, aState])

  useEffect(() => {
    console.log({ aState })
  }, [aState])

  useEffect(() => {
    let prodId = query.get('productId') || location.state?.productId
    const currentURL = window.location.href
    console.log({ currentURL })
    for (const key in prodMap) {
      if (currentURL.includes(key)) {
        console.log('product: ', prodMap[key])
        prodId = prodMap[key]
      }
    }
    verifyAuthentication()
    storeProductId(prodId)
  }, [])

  useEffect(() => {
    const code = query.get('affiliateCode')
    if (code) {
      setAffiliateCode(code)
      saveItem('affiliateCode', code)
    }
  }, [query])

  // console.log('affiliateCode from url:', affiliateCode)
  // console.log('userSourceCode from url:', userSourceCode)
  useEffect(() => {
    if (productId === '4127') return
    const fetchCompanyLogo = async () => {
      const input = {
        prsCode: '3702A702',
        userSourceCode,
      }
      const res = await axios.post(`${apiURL}`, input)
      const {
        data: { responsePayload: verifyInfoRes },
      } = res
      if (verifyInfoRes && verifyInfoRes.statusCode === 200) {
        setOrgObject((prev) => ({
          ...prev,
          orgName: verifyInfoRes.distributorName,
          companyLogo: verifyInfoRes.businessLogo,
        }))
      }
    }
    const verifyAccount = async () => {
      const input = {
        prsCode: '3702D702',
        affiliateCode,
        userSourceCode,
      }
      try {
        const res = await axios.post(`${apiURL}`, input)
        const {
          data: { responsePayload: verifyAccountRes },
        } = res
        if (!verifyAccountRes) return
        if (verifyAccountRes.statusCode === 201) {
          setInvalidUrl(true)
          setUrlErrorMessage('We are not able associate agent with the distributor, please contact your admin.')
        } else if (verifyAccountRes.statusCode === 200) {
          setInvalidUrl(false)
          setUrlErrorMessage('')
        }
      } catch (error) {
        console.error(error)
      }
    }
    const getAlerts = async () => {
      const input = {
        prsCode: '3702M702',
        affiliateCode,
        distributorId: userSourceCode,
      }
      const res = await axios.post(`${apiURL}`, input)
      const {
        data: { responsePayload },
      } = res
      if (responsePayload.statusCode === 201) {
        setAlerts([])
        return
      }
      Array.isArray(responsePayload.alerts) && setAlerts(responsePayload.alerts)
    }
    const getPhotoAndFullName = async () => {
      // call getaffiliatedashinfo api
      try {
        const input = {
          prsCode: prsCodes.getAffiliateDashInfo,
          affiliateCode,
        }
        const res = await axios.post(`${apiURL}`, input)
        const responsePayload = res?.data?.responsePayload || res?.data
        if (responsePayload) {
          setAgentObject((prev) => ({
            ...prev,
            firstName: responsePayload.agentFirstName,
            lastName: responsePayload.agentLastName,
            photo: responsePayload.agentPhoto,
          }))
          return
        }
      } catch (error) {
        console.error(error)
      }
    }

    if (userSourceCode) {
      fetchCompanyLogo()
    }
    if (affiliateCode) {
      getPhotoAndFullName()
    }
    if (affiliateCode && userSourceCode) {
      verifyAccount()
      getAlerts()
    }
  }, [affiliateCode, userSourceCode])

  useEffect(() => {
    if (loggingIn || !loginData) return

    console.log({ loginData })
    let state = {
      ...authObj,
      otpFlag: loginData.otpFlag,
      user: {
        email: loginData.login,
        firstName: loginData.FirstName,
        lastName: loginData.LastName,
        distributorId: loginData.distributorId,
        npn: loginData.npn,
      },
    }
    setAuthObj(state)

    console.log('affiliateCode:', loginData.affiliateCode)
    setAffiliateCode(loginData.affiliateCode)

    if (productId === '511801') {
      console.log('calling agent verify: ', loginData.affiliateCode)
      mutateAgentVerify({
        productId: '511801',
        distributorId: 5184,
        agentFirstName: loginData.FirstName,
        agentLastName: loginData.LastName,
        agentEmail: loginData.login,
        agentNPN:
          `${loginData.npn}`.length === 8
            ? `${loginData.npn}`
            : `${Array.from({ length: 8 - `${loginData.npn}`.length })
                .map(() => '0')
                .join('')}${loginData.npn}`,
        agentID: loginData.affiliateCode.split('CG')[1],
        password: loginPassword,
      })
    } else {
      saveItem('authObj', JSON.stringify(state))
      saveItem('affiliateCode', loginData.affiliateCode)
      getUserPersona(loginData.login)
    }
  }, [loginData, loggingIn])

  useEffect(() => {
    if (ssoLoggingIn || !ssoData) return
    console.log({ ssoData })
    let state = {
      ...authObj,
      isAuthenticated: true,
      user: {
        ...authObj.user,
        firstName: ssoData.firstName,
        lastName: ssoData.lastName,
      },
      relationalType: 117,
    }
    setAuthObj(state)
    saveItem('authObj', JSON.stringify(state))
    let agentState = {
      ...agentObject,
      firstName: ssoData.firstName || '',
      lastName: ssoData.lastName || '',
    }
    setAgentObject(agentState)
    saveItem('agentObject', JSON.stringify(agentState))
    navigate(`/`, { state: { affiliateCode: affiliateCode, productId: productId } })
    // navigate(`/application-management`, { state: { affiliateCode: affiliateCode, productId: productId } })
  }, [ssoData, ssoLoggingIn])

  useEffect(() => {
    console.log({ authObj })
  }, [authObj])

  useEffect(() => {
    if (gettingPersona || !personaData) return
    console.log({ personaData })
    let state = {
      ...authObj,
      isAuthenticated: true,
      relationalType: personaData.relationalType,
      userSourceCode: personaData.userSourceId,
    }
    setAuthObj(state)
    saveItem('authObj', JSON.stringify(state))
    if (authObj?.user?.firstName || authObj?.user?.lastName) {
      let agentState = {
        ...agentObject,
        firstName: authObj.user.firstName || '',
        lastName: authObj.user.lastName || '',
      }
      setAgentObject(agentState)
      saveItem('agentObject', JSON.stringify(agentState))
    }
    navigate(`/`, { state: { affiliateCode: affiliateCode, productId: productId } })
    // navigate(`/application-management`, { state: { affiliateCode: affiliateCode, productId: productId } })
  }, [personaData, gettingPersona])

  const logout = async () => {
    const state = {
      isAuthenticated: false,
      otpFlag: false,
      user: null,
      relationalType: null,
      userSourceCode: null,
    }
    // saveItem('authObj', JSON.stringify(state))
    setAuthObj(state)
    // saveItem(
    //   'agentObject',
    //   JSON.stringify({
    //     firstName: '',
    //     lastName: '',
    //     photo: null,
    //   })
    // )
    await localforage.clear()
    setAgentObject({
      firstName: '',
      lastName: '',
      photo: null,
    })
    navigate('/', { state: { affiliateCode: null, productId: productId } })
  }

  const authState = {
    userSourceCode,
    affiliateCode,
    orgObject,
    agentObject,
    invalidUrl,
    urlErrorMessage,
    alerts,
    setAlerts,
    login,
    loggingIn,
    loginError,
    isLoginError,
    company,
    authObj,
    ssoLogin,
    logout,
    productId,
    isAgentVerifyError,
    agentVerifyError,
    setIsAgentVerifyError,
    verifyingAgent,
    setLoginPassword,
  }

  return <AuthContext.Provider value={authState}>{children}</AuthContext.Provider>
}
